import { FC, useState } from 'react'
import { Button, Stack, Typography } from '@mui/material'

// 埋め込み (iframe) で セッション cookie が落ちたときに、ログインフォームの代わりに出す 1 タップの
// ゲート。タップを storage access の要求に使うためだけの画面なので、要素はボタン 1 つに絞る。
//
// ログインフォームを出してはならない。患者を開くたびに iframe が作り直される (実測で約 2.4 分に
// 1 回) ため、メールアドレスとパスワードの入力が同じ頻度で要求されることになり運用に耐えない
// (log/188 work-log/4 §3.1)。cookie 自体は 90 日生きており、必要なのは権利の取り直しだけ。
//
// cookie がまだ 1 つも無い初回でも、このタップには意味がある。ここで得た storage access は
// 「取り戻す」だけでなく「これから保存する」権利でもあり、続けて出るログインフォームで
// 入力した結果の Set-Cookie が iframe の中に保存できるようになる。実機ではこの経路で
// 患者画面まで到達している (log/188 work-log/10 §10)。
interface EmbedSessionGateProps {
  // 押下ハンドラ。requestStorageAccess() は transient user activation を要求するため、
  // このハンドラの内側で他の await を先に挟まないこと。
  onConnect: () => Promise<void>
}

export const EmbedSessionGate: FC<EmbedSessionGateProps> = ({ onConnect }) => {
  const [connecting, setConnecting] = useState(false)

  const handleClick = async () => {
    setConnecting(true)
    try {
      await onConnect()
    } finally {
      setConnecting(false)
    }
  }

  return (
    <Stack
      height="100vh"
      direction="column"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      px={3}
    >
      <Typography variant="h6" component="h1">
        Kakeru に接続します
      </Typography>
      {/*
        頻度は書かない。実機で測った結果このタップは起動時の 1 回だけで、患者を切り替えても
        再度は求められないため、頻度を書かなくても不安にならない (log/188 work-log/10 §10)。
        「一度だけ」と断定もしない。front はゲートを出した回数を持っておらず、
        許可を覚えるのはブラウザ側だから (同 §9.4.1)。

        「このブラウザでは」「薬歴画面から開いた」も落とした。押せば次に進む画面なので、
        利用者が判断に使う情報は「押す必要がある」の 1 点しかない。
      */}
      <Typography variant="body2" color="text.secondary" textAlign="center">
        Kakeru を使うには、接続の許可が必要です。
      </Typography>
      <Button variant="contained" disabled={connecting} onClick={handleClick}>
        接続する
      </Button>
    </Stack>
  )
}
